"use client";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import Link from "next/link";

// "Key Highlights" carousel — same design as LeaveMainFeatures (Swiper slider,
// each slide: image + title link + description + 4-item checklist). Data-driven
// so any WhatsApp hub can reuse it.
export default function CrmKeyHighlights({ data }) {
  if (!data || !data.items?.length) return null;
  return (
    <div className="container position-relative">
      <div className="pt-80 pb-80 pt-sm-70 pb-sm-70 px-4 bg-gray-light-1">
        <div className="row">
          <div className="col-lg-12 wow fadeInUp">
            <div className="row">
              <div className="col-md-10 offset-md-1 text-center">
                <h2 className="section-title mb-70 mb-sm-40">{data.title}</h2>
              </div>
            </div>
            <div className="overflow-hidden">
              <Swiper
                rewind
                spaceBetween={0}
                slidesPerView={1}
                modules={[Navigation]}
                navigation={{ prevEl: ".crm-highlight-prev", nextEl: ".crm-highlight-next" }}
                watchSlidesProgress
                resizeObserver
                style={{ opacity: 1, display: "block" }}
                className="testimonials-slider-1 owl-carousel owl-theme pb-xs-80 overflow-visible position-static"
              >
                {data.items.map((item, i) => (
                  <SwiperSlide className="owl-item" key={i}>
                    <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                      <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                        <div className="position-relative overflow-hidden">
                          <Image
                            width={1200}
                            height={700}
                            src={item.image}
                            className="image-fullwidth relative"
                            alt={item.title}
                            style={{ borderRadius: "10px" }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                        <div className="position-relative">
                          <div className="text-center text-lg-start">
                            <Link href={item.href}>
                              <h3 className="h3">{item.title}</h3>
                            </Link>
                            <p className="text-gray">{item.description}</p>
                            <div className="row py-3">
                              {item.checklist.map((c, j) => (
                                <div className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1" key={j}>
                                  <div className="features-list-icon">
                                    <i className="mi-check" />
                                  </div>
                                  <div className="text-sm">{c}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
                <div className="owl-controls clickable">
                  <div className="text-center">
                    <div className="owl-prev crm-highlight-prev" role="button" tabIndex="0">
                      <span className="visually-hidden">Previous Slide</span>
                      <i className="mi-arrow-left" aria-hidden="true"></i>
                    </div>
                    <div className="owl-next crm-highlight-next" role="button" tabIndex="0">
                      <span className="visually-hidden">Next Slide</span>
                      <i className="mi-arrow-right" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
